import React from 'react'
import LogoImg from '../../../img/LogoWorkServices.jpg'

export const Logo = () => {
  return (
    <img src={LogoImg} alt="" className='imgPerson'/>
  )
}
